export default __webpack_public_path__ + "static/media/logo.ae1d800d.png";